<ng-container *ngIf="showcaseOptionGroups?.length">
    <ms-showcase-option-group
        *ngFor="let optionGroup of showcaseOptionGroups; trackBy: trackOptionGroup; let index = index"
        [model]="optionGroup"
        [event]="event"
        [tracking]="tracking"
        [viewType]="viewType">
    </ms-showcase-option-group>
</ng-container>
